import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchRevealData = createAction(constants.FETCH_REVEAL_DATA)
export const fetchRevealDataPending = createAction(constants.FETCH_REVEAL_DATA_PENDING)
export const fetchRevealDataSuccess = createAction(constants.FETCH_REVEAL_DATA_SUCCESS)
export const fetchRevealDataFailed = createAction(constants.FETCH_REVEAL_DATA_FAILED)
export const fetchRevealDataCancelled = createAction(constants.FETCH_REVEAL_DATA_CANCELLED)

export const fetchRevealDataByIp = createAction(constants.FETCH_REVEAL_DATA_BY_IP)
export const fetchRevealDataByIpPending = createAction(constants.FETCH_REVEAL_DATA_BY_IP_PENDING)
export const fetchRevealDataByIpSuccess = createAction(constants.FETCH_REVEAL_DATA_BY_IP_SUCCESS)
export const fetchRevealDataByIpFailed = createAction(constants.FETCH_REVEAL_DATA_BY_IP_FAILED)
export const fetchRevealDataByIpCancelled = createAction(constants.FETCH_REVEAL_DATA_BY_IP_CANCELLED)
export const fetchRevealDataBySourceProperties = createAction(constants.FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES)
export const fetchRevealDataBySourcePropertiesPending = createAction(constants.FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_PENDING)
export const fetchRevealDataBySourcePropertiesSuccess = createAction(constants.FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_SUCCESS)

export const showRevealData = createAction(constants.SHOW_REVEAL_DATA)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/actions.js